import React from "react";
// import "../styles/Resources.css";

const resources = [
  {
    title: "Academic Integrity Policy",
    description:
      "Academic integrity is central to LINC Education's commitment and promise to its partners, students, academic professionals and staff. Without honesty and integrity, our learning community has no substance or validity. Please read our policy for details on how we uphold our academic standards.",
       link: "https://s3-ap-southeast-2.amazonaws.com/linc-timeline/LINC+Academic+Integrity+Policy.pdf",
  },
  {
    title: "Analytics Library",
    description:
      "The Linc Quality Hub holds a wealth of information for teaching team and administrators. Be it tracking course engagement or understanding student issues, you can use the Quality Hub to uncover a wide range of valuable analytics on your course. Read the complete guide to all the analytics, KPIs and information available in Linc Quality Hub.",
       link: "https://s3.ap-southeast-2.amazonaws.com/linc-timeline/NC+Analytics+Library_QH.pdf",
  },
  {
    title: "Privacy Policy",
    description:
      "LINC Education Services Pte. Ltd. is committed to keeping personal information safe. We will take all necessary measures to fulfill this commitment. Please read our privacy policy to learn more.",
       link: "https://s3-ap-southeast-2.amazonaws.com/linc-timeline/LINC+Privacy+Policy.pdf",
  },
  {
    title: "Quality Control Process",
    description:
      "Ensuring consistency of academic support and advice across our coaches and facilitators is a key component of LINC’s value proposition as a managed services provider. Please read our quality control document to learn more.",
       link: "https://s3-ap-southeast-2.amazonaws.com/linc-timeline/LINC+Ongoing+Quality+Control+Process.pdf",
  },
];

const Resources = () => {
  return (
    <div className="resources-page">
      <div className="resources-header">
        <h2>Resources</h2>
      </div>

      <div className="resources-container">
        {resources.map((item, index) => (
          <div className="resource-card" key={index}>
            <h5 className="bold mb-2">{item.title}</h5>
            <p>{item.description}</p>
              <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="read-more"
            >
              Read More
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Resources;
